import HomeAnimation from './HomeAnimation';

export default HomeAnimation;